import { Filter } from '@empathy/search-types';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { FacetGroup, FacetsGroupConfig } from '../../models';
import { GETTERS_KEYS, RootStoreState } from '../../store';

@Component
export class FacetsGroupMixin extends Vue {
  @Prop({ required: true })
  groupId: string;

  get facetGroupConfig(): FacetsGroupConfig {
    return this.$store.getters[GETTERS_KEYS.config.facetsGroups][this.groupId];
  }

  get facetsGroup(): FacetGroup {
    return (this.$store.state as RootStoreState).search.facetsGroups[this.groupId];
  }

  get groupSelectedFilters(): Filter[] {
    return this.$store.getters[GETTERS_KEYS.search.selectedFiltersByGroup][this.groupId];
  }
}
